import type { IApplication } from "./application.interface";

export enum ProductType {
    FOR_SALE = "for_sale",
    REWARD = "reward",
}

export enum DeliveryType {
    PHYSICAL = "physical",
    DIGITAL = "digital",
}

export interface IProduct {
    _id: string;
    application: IApplication | string;
    name: string;
    description: string;
    image: string;
    price: number;
    points: number;
    type: ProductType;
    deliveryType: DeliveryType;
    stock?: number;
    metadata?: any;
    updatedAt: string;
    createdAt: string;
    deletedAt?: string;
}
